import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)({
  width: '100%',
  position: 'relative',
  height: 'var(--app-height)',
  minHeight: '550px',
});

export const NavPanel = styled(Box)({
  position: 'absolute',
  width: '100%',
  bottom: '0',
  transform: 'translateX(-50%)',
  left: '50%',
  zIndex: 2,
});

export const ScreenWrapper = styled(Box)<{ $background: string }>(({ $background }) => ({
  width: '100%',
  height: '100%',
  background: $background || 'white',
}));
